import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import VendorAlotDrawer from "components/drawer/VendorAlotDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

import { Modal, Box, Typography, IconButton } from "@mui/material";
import EditButton from "components/table/EditButton";
import ViewModal from "components/modal/ViewVendorAlotModal";

import AlotButton from "components/table/VendorAlotButton";
import ItineraryModal from "components/form/ItineraryModal";

import React, { useState } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import RemarkModal from "components/modal/RemarkModal";
import { FiFile } from "react-icons/fi";
import Tooltip from "@mui/material/Tooltip";
import { MdClose } from "react-icons/md"; // Import MdClose from react-icons
// internal imports

const VendorAllotTable = ({
  vendoralot,
  perpage,
  currentPage,
  tab,
  hideAdd,
  hideEdit
}) => {
  const {
    title,
    serviceBlock,
    start_date,
    end_date,
    vendor_id,
    latest_va_id,
    vendor_name,
    days,
    serviceId,
    handleModifyUpdate,
    handleModalOpen,
    handleVendorUpdate,
    PackageType,
    is_vehicle_alloted,
    vendorAction,
    vendorAllotAction,
    clientArrived,
    tripWentOrNot,
  } = useToggleDrawer();
  // const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [changedname, setChangedName] = useState("");
  const [itinerary, setItinerary] = useState("");
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const handleOpen = (item) => {
    const reason = item?.reason || "";

    if (/<[a-z][\s\S]*>/i.test(reason)) {
      setSelectedRemark(<div dangerouslySetInnerHTML={{ __html: reason }} />);
    } else {
      setSelectedRemark(reason); // <-- use reason instead of remark
    }

    setChangedName(item?.change_type);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={vendoralot} />

      <MainDrawer>
        <VendorAlotDrawer
          id={serviceId}
          start_date={start_date}
          end_date={end_date}
          latest_va_id={latest_va_id}
          tab={tab}
          vendor_id={vendor_id}
          vendor_name={vendor_name}
          days={days}
          package_type={PackageType}
          is_vehicle_alloted={is_vehicle_alloted}
          vendorAction={vendorAction}
          vendorAllotAction={vendorAllotAction}
          clientArrived={clientArrived}
          tripWentOrNot={tripWentOrNot}
        />
      </MainDrawer>

      <TableBody>
        {vendoralot?.slice(0, perpage).map((data, index) => (
          <TableRow
            key={data.id}
            className={data.status === 1 ? "bg-red-100" : ""}
          >
            <TableCell className="text-center text-sm">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-center text-sm">{data.ref_no}</TableCell>
            <TableCell className="text-center text-sm">
              {data.client_name}
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.start_date}</span>
              <br />
              <span className="text-sm">{data.end_date}</span>
            </TableCell>

            <TableCell className="text-center text-sm">
              {data.no_of_days}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data?.vehiclename}
            </TableCell>
            <TableCell className="text-center text-sm">
              <div className="flex flex-col gap-3">
                <span className="text-sm text-teal-500">
                  {data.arrival_name}
                </span>
                <span className="text-sm text-yellow-700">
                  {data.departure_name}
                </span>
              </div>
            </TableCell>

            <TableCell className="text-center text-sm">
              {data.package_type}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.itinerary ? (
                <span className="text-sm cursor-pointer flex justify-center items-center">
                  <span
                    onClick={() => {
                      setShowItineraryModal(true);
                      setItinerary(data.itinerary);
                    }}
                    title="Itinerary"
                  >
                    <FiFile className="text-2xl text-green-500 hover:text-green-600" />
                  </span>
                </span>
              ) : (
                <span>-</span>
              )}
            </TableCell>

            {/* franchise names */}
            <TableCell className="text-center text-sm">
              {(data.allotment_history || []).map((item, index) => (
                <div key={index}>
                  <span
                    className={`text-sm ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item.franchise_name || "-"}
                  </span>
                </div>
              ))}
            </TableCell>
            {/* vendor names */}
            <TableCell className="text-center text-sm">
              {(data.allotment_history || []).map((item, index) => (
                <div key={index}>
                  <span
                    className={`text-sm ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item.vendor_name || "-"}
                  </span>
                </div>
              ))}
            </TableCell>

            {/* <TableCell className="text-center text-sm">
              {(data?.allotment_history || []).map((item, index) => (
                <Tooltip
                  key={item.va_id || index}
                  title={item?.trip_status_text || ""}
                  arrow
                  placement="top"
                >
                  <div
                    className={`cursor-pointer ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item?.va_start_date || "-"} - {item?.va_end_date || "-"}
                  </div>
                </Tooltip>
              ))}
            </TableCell> */}

            <TableCell className="text-center text-sm">
              {(data?.allotment_history || []).map((item, index) => (
                <div
                  key={item.va_id || index}
                  className={`cursor-pointer ${
                    item.status === "Present" ? "text-black" : "text-red-600"
                  }`}
                >
                  {item?.trip_status_text === "Not Went"
                    ? item.trip_status_text
                    : `${item?.va_start_date || "-"} - ${item?.va_end_date || "-"}`}
                </div>
              ))}
            </TableCell>

            <TableCell className="text-center text-sm">
              {(data.allotment_history || []).map((item, index) => (
                <React.Fragment key={index}>
                  {item.reason?.trim() ? (
                    <>
                      <span
                        className="text-blue-500 cursor-pointer"
                        onClick={() => handleOpen(item)}
                      >
                        Remark
                      </span>
                      <br />
                    </>
                  ) : (
                    <>
                      <span>-</span>
                      <br />
                    </>
                  )}
                </React.Fragment>
              ))}
            </TableCell>

            <TableCell className="text-center text-sm">
              {data.vehiclename}
            </TableCell>

            <TableCell className="text-center">
              {data.vehicle_note ? (
                <span
                  className="text-sm text-blue-500 cursor-pointer"
                  onClick={() => handleOpen(data.vehicle_note)}
                >
                  View
                </span>
              ) : (
                <span className="text-sm text-center">-</span>
              )}
            </TableCell>
            <TableCell className="text-center text-sm">
              <span
                className={`px-2 py-1 rounded-full text-sm mb-0 font-semibold ${
                  data?.trip_status === "Upcoming"
                    ? "text-blue-700"
                    : data?.trip_status === "Ongoing"
                      ? " text-yellow-700"
                      : data?.trip_status === "Completed"
                        ? " text-green-700"
                        : data?.trip_status === "Cancelled"
                          ? " text-red-700"
                          : " text-gray-700"
                }`}
              >
                {data?.trip_status}
              </span>
            </TableCell>

            <TableCell className="text-center">
              {data.status === 1 ? (
                <span>-</span>
              ) : hideEdit ? (
                (() => {
                  const [sd, sm, sy] = data.start_date.split("-");
                  const [ed, em, ey] = data.end_date.split("-");
                  const startDate = new Date(`${sy}-${sm}-${sd}`);
                  const endDate = new Date(`${ey}-${em}-${ed}`);
                  const today = new Date();
                  startDate.setHours(0, 0, 0, 0);
                  endDate.setHours(0, 0, 0, 0);
                  today.setHours(0, 0, 0, 0);
                  const canAllot = data?.can_allot;
                  const canEdit = data?.can_modify;
                  const isTab2 = tab === 2;

                  return canAllot ? (
                    <AlotButton
                      id={data.id_client}
                      vendorid={data.vendor_id}
                      package_type={data.package_type}
                      handleVendorUpdate={handleVendorUpdate}
                      handleModalOpen={handleModalOpen}
                      latest_va_id={data.latest_va_id}
                      vendorAllotAction="allot"
                      start_date={
                        data.allotment_history?.find(
                          (item) => item.status === "Present",
                        )?.va_start_date || null
                      }
                      end_date={
                        data.allotment_history?.find(
                          (item) => item.status === "Present",
                        )?.va_end_date || null
                      }
                    />
                  ) : canEdit ? (
                    <EditButton
                      vendor_name={data.vendor_name}
                      vendor_id={data.vendor_id}
                      latest_va_id={data.latest_va_id}
                      id={data.id_client}
                      start_date={
                        data?.allotment_history
                          ?.flatMap((item) => item.driver_vehicle_history || [])
                          ?.find((item) => item.status === "Present")
                          ?.va_start_date ||
                        data?.allotment_history?.find(
                          (item) => item.status === "Present",
                        )?.va_start_date ||
                        null
                      }
                      end_date={
                        data?.allotment_history
                          ?.flatMap((item) => item.driver_vehicle_history || [])
                          ?.find((item) => item.status === "Present")
                          ?.va_end_date ||
                        data?.allotment_history?.find(
                          (item) => item.status === "Present",
                        )?.va_end_date ||
                        null
                      }
                      days_count={data.no_of_days}
                      package_type={data.package_type}
                      tab={tab}
                      handleModifyUpdate={handleModifyUpdate}
                      handleModalOpen={handleModalOpen}
                      is_vehicle_alloted={
                        data?.allotment_history?.find(
                          (item) => item.status === "Present",
                        )?.is_driver_vehicle_alloted
                      }
                      vendorAction="modify"
                      clientArrived={data?.is_client_arrived}
                      tripWentOrNot={
                        // Once ANY driver/vehicle assignment across this
                        // booking's whole history was confirmed Went, the trip
                        // genuinely happened — a later reassignment's own
                        // outcome (even "Not Went") can't undo that fact. Read
                        // from the server-computed `ever_went` flag
                        // (models/vendorAllotModel.js) rather than the nested
                        // history JSON here — that JSON only carries the
                        // CURRENT driver/vehicle assignment per stint, so an
                        // earlier confirmed-Went leg swapped away from within
                        // the same vendor is invisible to it.
                        data?.ever_went === true
                          ? "1"
                          : data?.allotment_history
                              ?.flatMap(
                                (item) => item.driver_vehicle_history || [],
                              )
                              ?.find((item) => item.status === "Present")
                              ?.trip_went_or_not
                      }
                    />
                  ) : isTab2 ? (
                    <span
                      className={`text-sm ${
                        data.vendor_status === "Allotted"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {data.vendor_status}
                    </span>
                  ) : (
                    <span>-</span>
                  );
                })()
              ) : (
                <span>-</span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography variant="h5" sx={{ mb: 2 }}>
            Remark Details
          </Typography>

          <Typography
            variant="body1"
            sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
          >
            {/* {changedname && (
              <Typography
                variant="body2"
                sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
              >
                Change Type: {changedname}
              </Typography>
            )} */}
            {selectedRemark && (
              <Typography
                variant="body2"
                sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
              >
                Reason: {selectedRemark}
              </Typography>
            )}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default VendorAllotTable;
